import { Flex } from '@radix-ui/themes';
import { useAgent } from '@getdutchie/agent-react';
import { useAgentStatus } from '@/shared/use-agent-status';
import { FollowUps } from './follow-ups';
import { MessageInput } from './message-input';

interface PromptInputProps {
  disabled?: boolean;
}

export function PromptInput({ disabled }: PromptInputProps) {
  const { sendMessage, messages } = useAgent();
  const { isIdle } = useAgentStatus();

  const lastMessage = messages[messages.length - 1];
  const showFollowUps = !disabled && isIdle && lastMessage?.role === 'assistant';

  return (
    <Flex direction="column" gap="4">
      <FollowUps visible={showFollowUps} onSelect={sendMessage} />
      <MessageInput onSend={sendMessage} disabled={disabled} />
    </Flex>
  );
}
